import React from 'react';
import SectionHeader from 'v2/common/DRM/SectionHeader/SectionHeader';
import ToggleButton from 'v2/common/ToggleButton/ToggleButton';
import { useFieldMutation } from '../../hooks';
import { FieldTypeProps } from 'v2/common/DRM/CustomTab/Field/props';
import classNames from 'classnames';
import styles from '../../field.module.scss';

const BooleanField = ({
  fieldName,
  fieldLabel,
  value,
  entity,
  onUpdate,
  drmPage,
}: FieldTypeProps) => {
  const { mutate: updateFieldValue } = useFieldMutation({
    onUpdate,
    entity,
    drmPage,
    fieldName,
  });

  const handleOnChange = () => {
    updateFieldValue(!value);
  };

  return (
    <>
      <SectionHeader
        title={fieldLabel}
        className={classNames(styles.sectionHeader)}
      />
      <ToggleButton
        data-cy={`tab-field-${fieldName}-toggle`}
        onChange={handleOnChange}
        checked={Boolean(value)}
        disabled={!entity.is_editable}
      />
    </>
  );
};

export default BooleanField;
